(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#WholesaleEnquiry"]');
    const target = document.getElementById('WholesaleEnquiry');
    if (!link || !target || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const heading = target.querySelector('h2');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
    const header = document.querySelector('.section-header');
    const clearance = (header ? header.getBoundingClientRect().height : 0) + 24;
    window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - clearance, behavior: 'instant' });
    history.replaceState(null, '', '#WholesaleEnquiry');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jennys-cover"] && !Shopify.designMode) return;
  try {
    
(() => {
 const update = () => {
  const score = document.querySelector('.jr-live-reviews .yotpo-bottom-line-score')?.textContent.match(/\d+(?:\.\d+)?/)?.[0];
  const count = document.querySelector('.jr-live-reviews .yotpo-bottom-line-basic-text')?.textContent.match(/[\d,]+/)?.[0];
  if (!score || !count) return;
  const en = document.documentElement.lang.startsWith('en');
  document.querySelectorAll('[data-jr-live-proof]').forEach(el => {
   const text = en ? `★ ${score}/5 · ${count} customer reviews across our products` : `★ ${score}/5 · お客様のレビュー ${count}件（全商品）`;
   if(el.textContent !== text) el.textContent = text;
  });
 };
 const start = () => {const root=document.querySelector('.jr-live-reviews');if(root){new MutationObserver(update).observe(root,{childList:true,subtree:true,characterData:true});update();}};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jennys-shop-edit"] && !Shopify.designMode) return;
  try {
    
const updateFlavourOffer=(select)=>{const target=select.form.querySelector('[data-jr-flavour-estimate]');if(target)target.textContent=select.selectedOptions[0]?.dataset.estimate||'';};
const initFlavourOffers=()=>document.querySelectorAll('[data-jr-flavour-select]').forEach(updateFlavourOffer);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFlavourOffers);else initFlavourOffers();
document.addEventListener('shopify:section:load',initFlavourOffers);
document.addEventListener('change',event=>{if(event.target.matches('[data-jr-flavour-select]'))updateFlavourOffer(event.target);});

document.addEventListener('submit', async (event) => {
 const form=event.target;
 if(!(form instanceof HTMLFormElement) || !form.matches('.jr-quick-buy'))return;
 const offer=form.querySelector('input[name="return_to"]:checked');
 if(!offer)return;
 event.preventDefault();
 if(form.dataset.busy==='true')return;
 form.dataset.busy='true';
 const button=form.querySelector('button[type="submit"]');
 const en=document.documentElement.lang.startsWith('en');
 const root=window.Shopify.routes.root;
 button.disabled=true;
 const status=document.createElement('p');
 status.setAttribute('role','status');
 form.querySelector('[data-offer-status]')?.remove();
 status.dataset.offerStatus='';
 form.append(status);
 let added=false;
 try{
  const data=new FormData(form);
  data.delete('return_to');
  const add=await fetch(root+'cart/add.js',{method:'POST',body:data});
  const result=await add.json();
  if(!add.ok)throw new Error(result.description || (en?'Unable to add this item.':'商品を追加できませんでした。'));
  added=true;
  const update=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:'WELCOME20'})});
  if(!update.ok)throw new Error(en?'The item was added, but the offer could not be updated. Please check your cart.':'商品を追加しましたが、クーポンを更新できませんでした。カートをご確認ください。');
  window.location.assign(root+'cart');
 }catch(error){
  status.textContent=error.message;
  if(added){
   const link=document.createElement('a');
   link.href=root+'cart';
   link.textContent=en?' View cart':' カートを見る';
   status.append(link);
  }else{
   button.disabled=false;
   form.dataset.busy='false';
  }
 }
});

  } catch(e) { console.error(e); }
})();
})();
